import { Card, CardContent } from "../../../../../../components/ui/card";

export const FitmentTab: React.FC = () => {
  return (
    <Card>
      <CardContent className="p-6">
        <h3 className="text-lg font-medium">Fitment Data</h3>
        {/* Fitment content will be added here */}
      </CardContent>
    </Card>
  );
}; 